import * as React from "react";

interface Props {
	style?: React.CSSProperties;
	colour?: string;
}

export const ASPECT_RATIO = 89 / 82;

const Connector: React.SFC<Props> = props => (
	<svg
		width="89"
		height="82"
		viewBox="0 0 89 82"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={props.style}
		preserveAspectRatio="xMidYMid"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M44.5 71C69.0767 71 89 56.4492 89 38.5C89 26.2457 79.7136 15.5754 66 10.0381V0H23V10.0381C9.28644 15.5754 0 26.2457 0 38.5C0 56.4492 19.9233 71 44.5 71Z"
			fill={props.colour}
		/>
	</svg>
);

// const Connector: React.SFC<Props> = props => (
// 	<svg
// 		width="89"
// 		height="71"
// 		viewBox="0 0 89 71"
// 		fill="none"
// 		xmlns="http://www.w3.org/2000/svg"
// 		style={props.style}
// 		preserveAspectRatio="xMidYMid"
// 	>
// 		<path
// 			fill-rule="evenodd"
// 			clip-rule="evenodd"
// 			d="M44.5 71C69.0767 71 89 56.4492 89 38.5C89 26.2457 79.7136 15.5754 66 10.0381V0H23V10.0381C9.28644 15.5754 0 26.2457 0 38.5C0 56.4492 19.9233 71 44.5 71Z"
// 			transform="translate(0 71) scale(1 -1)"
// 			fill={props.colour}
// 		/>
// 	</svg>
// );

Connector.defaultProps = {
	colour: "#C4C4C4"
};

export default Connector;



// WEBPACK FOOTER //
// ./src/components/Jigsaw/Connector.tsx